nativeBannersData = {
  "Default": [],
  "DefaultAndVideo": [
    {
      "BannerDefinitions": {},
      "Duration": 12,
      "End": "2029-07-01T00:00:00",
      "EventID": null,
      "IsVideo": true,
      "LimitAge": true,
      "Link": "https://screens-cf.doxxbet.sk/screens/1920x1080/DOXX_FUTBAL_WEB_titulky.mp4",
      "ShowWinners": false,
      "Start": "2021-02-16T14:58:00",
      "VideoFormat": "video/mp4"
    },
    {
      "BannerDefinitions": {},
      "Duration": 24,
      "End": "2021-10-07T10:05:00",
      "EventID": null,
      "IsVideo": true,
      "LimitAge": true,
      "Link": "https://screens-cf.doxxbet.sk/screens/1920x1080/sb-ad-map_1.mp4",
      "ShowWinners": false,
      "Start": "2021-02-16T14:58:00",
      "VideoFormat": "video/mp4"
    },
    {
      "BannerDefinitions": {
        "ro": {
          "EventDate": "0001-01-01T01:00:00",
          "EventName": null,
          "LanguageID": "ro",
          "Tags": null,
          "Text": null
        }
      },
      "Duration": 12,
      "End": "2029-07-01T00:00:00",
      "EventID": null,
      "IsVideo": true,
      "LimitAge": true,
      "Link": "https://screens-cf.doxxbet.sk/screens/1920x1080/DOXX_FUTBAL_WEB_titulky.mp4",
      "ShowWinners": false,
      "Start": "2021-02-16T14:58:00",
      "VideoFormat": "video/mp4"
    },
    {
      "BannerDefinitions": {
        "ro": {
          "EventDate": "0001-01-01T01:00:00",
          "EventName": null,
          "LanguageID": "ro",
          "Tags": null,
          "Text": null
        }
      },
      "Duration": 24,
      "End": "2021-10-07T10:05:00",
      "EventID": null,
      "IsVideo": true,
      "LimitAge": true,
      "Link": "https://screens-cf.doxxbet.sk/screens/1920x1080/sb-ad-map_1.mp4",
      "ShowWinners": false,
      "Start": "2021-02-16T14:58:00",
      "VideoFormat": "video/mp4"
    },
    {
      "BannerDefinitions": {
        "ro": {
          "EventDate": "0001-01-01T01:00:00",
          "EventName": null,
          "LanguageID": "ro",
          "Tags": null,
          "Text": null
        }
      },
      "Duration": 10,
      "End": "2029-01-01T00:00:00",
      "EventID": null,
      "IsVideo": false,
      "LimitAge": true,
      "Link": "https://screens-cf.doxxbet.sk/screens/1920x1080/futbal-zacina-sb-horna.jpg",
      "ShowWinners": false,
      "Start": "2021-02-16T14:58:00",
      "VideoFormat": null
    },
    {
      "BannerDefinitions": {
        "ro": {
          "EventDate": "0001-01-01T01:00:00",
          "EventName": null,
          "LanguageID": "ro",
          "Tags": null,
          "Text": null
        }
      },
      "Duration": 5,
      "End": "2029-07-01T00:00:00",
      "EventID": null,
      "IsVideo": false,
      "LimitAge": true,
      "Link": "https://screens-cf.doxxbet.sk/screens/1920x1080/betbuilder-sb-en.jpg",
      "ShowWinners": false,
      "Start": "2021-02-16T14:58:00",
      "VideoFormat": null
    },
    {
      "BannerDefinitions": {
        "ro": {
          "EventDate": "0001-01-01T01:00:00",
          "EventName": null,
          "LanguageID": "ro",
          "Tags": null,
          "Text": null
        }
      },
      "Duration": 15,
      "End": "2021-07-01T00:00:00",
      "EventID": null,
      "IsVideo": true,
      "LimitAge": true,
      "Link": "https://screens-cf.doxxbet.sk/screens/1920x1080/bet-builder-final2-no-audio-5mb.mp4",
      "ShowWinners": false,
      "Start": "2021-02-16T14:58:00",
      "VideoFormat": "video/mp4"
    }
  ],
  "ShowBannerVirtuals": false,
  "Special": {},
  "SpecialAndVideo": {
    "Banners": [
      {
        "BannerDefinitions": {
          "ro": {
            "EventDate": "0001-01-01T00:00:00",
            "EventName": null,
            "LanguageID": "ro",
            "Tags": null,
            "Text": null
          }
        },
        "Duration": 10,
        "End": "2027-03-01T16:24:00",
        "EventID": null,
        "IsVideo": false,
        "LimitAge": true,
        "Link": "https://screens-cf.doxxbet.sk/screens/1920x1080/bet-nebet-24-SB-horna_(2).jpg",
        "ShowWinners": false,
        "Start": "2024-10-25T00:00:00",
        "VideoFormat": null
      }
    ],
    "From": "2024-10-25T00:00:00",
    "To": "2027-04-28T23:59:00"
  },
  "Tutorials": []
};

test = function (type) {
  switch (type) {
    case 'statsTable':
      // OK
      // Prematch close (FORCED)
      // listenTopScreen('statsTable','{"screenShow":false}');

      // League table Show
      // listenTopScreen('statsTable','{"screenShow":true,"screenFor":"league","sportID":54,"regionID":251,"leagueID":653,"seasonID":66441,"eventID":null}');

      // Prematch (Analysis) Show
      listenTopScreen('statsTable', '{"screenShow":true,"screenFor":"event","sportID":50,"regionID":null,"leagueID":null,"seasonID":null,"provider":null,"eventID":69131130}');
      break;
    case 'loadBanners':
      // OK
      // LoadBanners
      listenTopScreen('loadBanners', nativeBannersData);
      break;
    case 'video':
      // OK
      // Video Show
      listenTopScreen('video', '{"Type": "video/mp4", "VideoLink":"https://screens-cf.doxxbet.sk/screens/1920x1080/sb-ad-map_1.mp4"}');
      break;
    case 'restart':
      // OK
      // Restart (hide All)
      listenTopScreen('restart');
      // Reload Top Screen available when nativeApp:
      // ReloadTop();
      break;
    case 'jackpot':
      // OK
      // Jackpot Load data - Show only between banners
      listenTopScreen('jackpot');
      break;
    case 'jackpotChanged':
    case 'JackpotChanged':
      // OK
      // Jackpot Change- Sports betting
      // listenTopScreen('jackpotChanged', '{"jackpotCode":"sbox_sb","jackpotValue":123.08}');
      // Jackpot Change - Virtual games
      listenTopScreen('jackpotChanged', '{"jackpotCode":"sbox_vg","jackpotValue":456.78}');
      break;
    case 'quickbet':
      // OK
      // Quickbet Hide
      // listenTopScreen('quickbet', {'token': false});

      // Quickbet Show
      listenTopScreen('quickbet', { 'token': 'eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNyc2Etc2hhMjU2Iiwia2lkIjoiODYzMmJiZGQtN2MwNC00ZTk2LWI0NWMtN2ZjOWU0Nzk3MTI0IiwidHlwIjoiSldUIn0.eyJjbGllbnRJZCI6IjExMDQwNDYiLCJwbGF0Zm9ybSI6InNwb3J0Ym94IiwicGxheWVySWQiOiIwIiwibGFuZ3VhZ2VJZCI6InNrIiwidGlja2V0UmVmU291cmNlIjoiIiwiZXhwIjoxNzA2NTQ2NTUzfQ.GhsED4_dDE9QueJQUG_b29h6z-FLwRdX_TkXFfhbaw7gSOMEmjJB01NmgcZLNjodNsgRzQu2aJWcgSmr_WXXiiJxvY8pBDk3j0hHUBF7-Zz2hanVUeNsgWqASnk7pmB5eu-NtTXQ1KCZ5Q3ffdy1SHbZXOig89-Rx4rauBZ8G1_BNQb9rdmqmYCYE7H9AULr3jxca2wgTGPbSROblUTo3wzaqikWQZcnx3PQBSd27JEMjBmGEg3Peh2no6FaW4QnmOrO9HcBMONh7PGq7P9ncuW1Pi2u3pqOE_DmSkT_7qu4mGo6o0n1-8I2a5MiReh6yPQRkDPxIs0oEwRfGnzbjg' });
      break;
    case 'quickbetControl':
      // OK
      // Quickbet Control - switch event
      listenTopScreen('quickbetControl', { "data": { "event_id": "change_event", "event_data": { "event_id": 452257 } } });
      break;
    case 'virtuals':
      // OK
      // Hide Virtual Game
      // listenTopScreen('virtuals', '{"screenShow":false, "channelID":0}');

      // Virtual Game Show  - Betradar - UOF Soccer Liga majstrov (VFCC)
      // listenTopScreen('virtuals', '{"screenShow":true,"gameID":1239,"leagueID":602502,"channelID":0}');
      // Virtual Game Show - Kiron - KRN Greyhounds Platinum Hounds
      listenTopScreen('virtuals', '{"screenShow":true,"gameID":1235,"leagueID":607002,"channelID":0}');
      break;
    case 'virtualsEvona':
      // TODO: test when available
      // Virtual Evona Game Show
      listenTopScreen('virtualsEvona', '{"Events":[{"RegionID":2139,"LeagueCupID":600204,"EventID":9902592,"EventName":"Pretek 9315","Score":"1,2,3,6,4,5","EventDate":"2019-08-22T09:49:17.4770000","Provider":"BTX","LiveFeedReference":"158382977"},{"RegionID":2139,"LeagueCupID":600204,"EventID":9902462,"EventName":"Pretek 9314","Score":"2,5,4,3,1,6","EventDate":"2019-08-22T09:39:17.4770000","Provider":"BTX","LiveFeedReference":"158382263"},{"RegionID":2139,"LeagueCupID":600204,"EventID":9902396,"EventName":"Pretek 9313","Score":"6,4,1,2,5,3","EventDate":"2019-08-22T09:29:17.4770000","Provider":"BTX","LiveFeedReference":"158381442"},{"RegionID":2139,"LeagueCupID":600204,"EventID":9902349,"EventName":"Pretek 9312","Score":"1,4,2,5,6,3","EventDate":"2019-08-22T09:19:17.4770000","Provider":"BTX","LiveFeedReference":"158380372"},{"RegionID":2139,"LeagueCupID":600204,"EventID":9902348,"EventName":"Pretek 9311","Score":"3,6,2,1,5,4","EventDate":"2019-08-22T09:09:17.4770000","Provider":"BTX","LiveFeedReference":"158379917"}],"LastEventOdds":[{"EventID":9902834,"TipName":"#1","OddsRate":3.68},{"EventID":9902834,"TipName":"#2","OddsRate":11.90},{"EventID":9902834,"TipName":"#3","OddsRate":46.00},{"EventID":9902834,"TipName":"#4","OddsRate":6.81},{"EventID":9902834,"TipName":"#5","OddsRate":1.67},{"EventID":9902834,"TipName":"#6","OddsRate":18.90}],"NextEventID":9897500}');
      break;
    case 'virtualsEvonaHub':
      // TODO: test when available
      // Virtual Evona Game Control
      // hubData = { eventID: '1234', streamUrl: '1234', raceId: '' };
      break;
    case 'lottery':
      // OK
      // Lottery close
      // listenTopScreen('lottery', '{"screenShow":false}');

      // Lottery show
      listenTopScreen('lottery', '{"screenShow":true,"leagueID":624205}');
      break;
    case 'showHelpSRT':
      // OK
      // Help SRT show
      listenTopScreen('showHelpSRT');
      break;
    case 'hideHelpSRT':
      // OK
      // Help SRT close
      listenTopScreen('hideHelpSRT');
      break;
    case 'biometryAutentification':
      // OK
      // BiometryLogin Result - success
      // listenTopScreen('biometryAutentification', '{"state": "success"}');
      // BiometryLogin Result - failed
      // listenTopScreen('biometryAutentification','{"state":"manyPlayers","info":""}');
      // BiometryLogin Result - failed
      // listenTopScreen('biometryAutentification','{"state":"unregisteredPlayer","info":""}');
      // BiometryLogin Result - failed
      // listenTopScreen('biometryAutentification', '{"state": "failed"}');
      // BiometryLogin Result - failed
      listenTopScreen('biometryAutentification','{"state":"canceled"}');
      // BiometryLogin Result - failed
      // listenTopScreen('biometryAutentification', '{"state": "failed"}');
      // NOK - TODO: kontrola
      // listenTopScreen('biometryAutentification','{"state":"gamblingProhibitedPlayer","info":""}');
      // NOK - TODO: kontrola
      // listenTopScreen('biometryAutentification','{"state":"failed","info":"angle"}');

      // BiometryLogin continue (called after camera has been initialized)
      // listenTopScreen('biometryAutentification', '{"state": "continuing"}');
      break;
    case 'biometryLogin':
      // OK
      // BiometryLogin Start
      listenTopScreen('biometryLogin', { loginBtnTimeStamp: new Date().getTime() });
      break;
    case 'biometryOnboarding':
      // OK
      // Show BiometryOnboarding - successfull scan front side of ID card
      // listenTopScreen('biometryOnboarding', '{"state": "idFrontSuccess"}');
      // Show BiometryOnboarding - failed scan front side of ID card
      // listenTopScreen('biometryOnboarding', '{"state": "idFrontFailed"}');
      // Show BiometryOnboarding - successfull scan front side of ID card - Scan back side of ID card
      // listenTopScreen('biometryOnboarding', '{"state": "idFrontSuccess", "nextStep": "idBack", "info": null}');
      // Show BiometryOnboarding - successfull scan front side of ID card - Player registered
      // listenTopScreen('biometryOnboarding', '{"state": "idFrontSuccess", "info": "registeredPlayer"}');

      // Show BiometryOnboarding - successfull scan back side of ID card
      // listenTopScreen('biometryOnboarding', '{"state": "idBackSuccess"}');
      // Show BiometryOnboarding - failed scan back side of ID card
      // listenTopScreen('biometryOnboarding', '{"state": "idBackFailed"}');

      // Show BiometryOnboarding - show selfie
      // listenTopScreen('biometryOnboarding', '{"state": "selfie", "nextStep": null, "info": null}');
      // Show BiometryOnboarding - successfull selfie
      // listenTopScreen('biometryOnboarding', '{"state": "selfieSuccess", "nextStep": null, "info": null}');
      // Show BiometryOnboarding - failed selfie
      listenTopScreen('biometryOnboarding', '{"state": "selfieFailed", "nextStep": null, "info": null}');
      break;
    case 'teamAnalysis':
      // OK
      // TeamAnalysis close
      // listenTopScreen('teamAnalysis', '{"regionID": 0}');
      // TeamAnalysis show
      listenTopScreen('teamAnalysis', '{"regionID": 1016, "teamOrder": 1}');
      break;
    case 'matchTracker':
      // OK
      // MatchTracker close
      // listenTopScreen('matchTracker', '{"eventID": 0}');
      // MatchTracker close (FORCED)
      // listenTopScreen('matchTracker', '{"eventID": 21612105}, true');

      // Matchtracker show
      listenTopScreen('matchTracker', '{"eventID": 21612105}');
      break;
    case 'matchTrackerControl':
      // OK
      // Matchtracker Control from webApp - matchTrackerControlPanel
      listenTopScreen('matchTrackerControl', '{"type":"tabs","selector":".sr-lmt-plus-tabs","findSelector":"button","selected":"1"}');
      break;
    case 'vlc':
      // OK
      // VLC close
      // listenTopScreen('vlc', '{"qrCode": false}');

      // VLC show
      listenTopScreen('vlc', '{"qrCode": "a1246789", "sbName": "SB123456"}');
      break;
    case 'stream':
      // NOK TODO: test when available
      // Na online mame viac providerov (UOF, betgenius, statsPerform, IMG....).
      // Tieto streamy vsak nieje mozne prehravat na sportboxoch (z dovodu licencovaneho obsahu - na sb sa vyzaduju specialne prava/licencie, ktore nemame zakupene).
      // Vynimkou su everymatrix (mtx) streamy - tu provider posiela len link na volne dostupne videa na platforme twitch, alebo YouTube, tam nie je ziadne obmedzenie.
 
      // Stream close (FORCED)
      // listenTopScreen("statsTable", '{"screenShow":true,"screenFor":"sport","sportID":58}');

      // Stream show
      listenTopScreen('stream', '{"screenShow":true,"screenFor":"event","sportID":82,"eStreamID":"https://fbstreambro.cc/embed.php/?match_id=1665286","provider":"MTX"}');
      break;
    case 'setLanguage':
      // OK
      // Set Language
      listenTopScreen('setLanguage', 'en');
      break;
    case 'test':
      // OK
      // synchronna odpoved na volanie spodnej app
      return 'If you can read this message on bottom screen, synchronous command from bottom app was successful';
      break;
    case 'test-cmd-to-bottom':
      // OK
      listenTopScreen('test-cmd-to-bottom', '{}', true);
      break;
    case 'toastNotification':
      // OK
      // Toast notification show
      listenTopScreen('toastNotification', '{"show":true,"text":"slon v konzerve je vzácna delikatesa","id":"AutoLogOff","timeout":10,"icon":"arrow-to-bottom-screen-stroke"}');
      break;
    case 'watcher':
      // OK
      // Watcher for media disable
      listenTopScreen('watcher', { time: Date() });
      break;
  }
}